import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGauge = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 16 16",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM4 8C4 5.79086 5.79086 4 8 4V2C4.68629 2 2 4.68629 2 8C2 11.3137 4.68629 14 8 14V12C5.79086 12 4 10.2091 4 8ZM9.93227 7.482L12.9498 4.46451L11.5355 3.05029L8.51809 6.06775C8.35285 6.02356 8.17918 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10C9.10457 10 10 9.10457 10 8C10 7.82086 9.97645 7.64721 9.93227 7.482Z",
		clipRule: "evenodd"
	})
});
export default SvgGauge;
